var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.components.close.close,{tag:"component",staticClass:"ebx-empathy-x__close"},[_c(_vm.components.close.icon,{tag:"component",staticClass:"ebx-close__icon",attrs:{"slot":"close-icon"},slot:"close-icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }